{
	"addressContinue": "Heimilisfang framhald",
	"affiliate": "Tengiliður",
	"comments": "Athugasemdir",
	"comments-more": "Athugasemdir",
	"contents": "Innihaldslýsing á ensku",
	"contentsValue": "Verðmæti innihalds (ISK)",
	"info-about-receiver": "Upplýsingar um viðtakanda",
	"info-about-sender": "Upplýsingar um sendanda",
	"info-about-shipment": "Upplýsingar um sendinguna",
	"messageType": "Tegund skilaboða",
	"messageTypeOptions": {
		"option1": "Ábending",
		"option2": "Kvörtun",
		"option3": "Hrós"
	},
	"mission": "Hvert er erindið?",
	"missionOptions": {
		"option1": "Bréfa/fjölpóstdreifing",
		"option2": "Vöru/pakkadreifing",
		"option3": "Almenn fyrirspurn"
	},
	"nameContinue": "Nafn framhald",
	"packageDescription": "Umbúðalýsing á ensku",
	"residence": "Tegund húsnæðis",
	"feedbackPlaceholder": "Skrifa hér...",
	"feedbackLabel": "Sendu okkur línu"
}
